export class FieldProducers {
    accountNumber: string;
    accountName: string;
    campaignId: number;
    fieldId: number;
}
